import { useMsal } from "@azure/msal-react";
import { Box, Button } from "@mui/material";
import Icons from "consts/svgIcons";
import { useEffect } from "react";
import { useGetUserState, useSetUserState } from "redux/user/userSlice";
import styles from "./styles.module.scss";

const Login = () => {
  const { instance } = useMsal();
  const user = useGetUserState();
  const { setUserFields } = useSetUserState();

  const handleLoginByMicrosoft = () => {
    instance
      .loginPopup()
      .then(() => {
        setUserFields({ ...user, checkUserLogin: true });
      })
      .catch((e: any) => {
        console.log("⚡️⚡️⚡️ ~ handleLoginByMicrosoft ~ e:", e);
      });
  };

  useEffect(() => {
    setTimeout(() => {
      if (!user.checkUserLogout) {
        handleLoginByMicrosoft();
      }
    }, 500);
  }, [user.checkUserLogout]);

  return (
    <div className={styles.rootContainer} style={{ height: window.innerHeight }}>
      <Box className={styles.paperBox}>
        <Button className={styles.buttonLoginMicrosoft} onClick={handleLoginByMicrosoft}>
          <Icons.MicrosoftIcon className={styles.microsoftLogo} />
          <span className={styles.textLogin}>Sign in with Microsoft</span>
        </Button>
      </Box>
    </div>
  );
};

export default Login;
